import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class OnSaleService {
  private apiUrlAuth = '';
  private apiUrlUnAuth = '';
  // Featured-frame READS now come from the new backend (site API). The admin
  // write methods below (add/update/delete/updateStatus) still target the old
  // backend — the customer pages never call them; the sales panel owns CRUD.
  private siteApi = '';

  constructor(private http: HttpClient) {
    this.apiUrlAuth = environment.apiUrlauth;
    this.apiUrlUnAuth = environment.apiUrlUnauth;
    this.siteApi = `${environment.newApiUrl}/api/site`;
  }

  filter(filter = '[]', orderBy = '[]', pageNumber = 0, pageSize = 10, type: string= 'list'): Observable<any[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('type', type);
    httpParams = httpParams.append('filter', filter);
    if (orderBy || orderBy != '') {
      httpParams = httpParams.append('orderBy', orderBy);
    }
    httpParams = httpParams.append('pageNumber', pageNumber.toString());
    if (pageSize || pageSize > 0) {
      httpParams = httpParams.append('pageSize', pageSize.toString());
    }
    return this.http.get<any[]>(this.siteApi + '/frames/featured', {
        params: httpParams
      })
      .pipe(
        map(res =>  res),
        catchError(this.handleError('filter', []))
      );
  }

  find(id, user_id): Observable<any> {
    return this.http.get<any>(this.siteApi + '/frames/featured-detail/' + id)
      .pipe(
        map(res => res),
        catchError(this.handleError('find', null))
      );
  }


  findByCaption(id, user_id): Observable<any> {
    return this.http.get<any>(this.siteApi + '/frames/featured-caption/' + id)
        .pipe(
            map(res => res),
            catchError(this.handleError('find', null))
        );
  }

  getFeaturedFramePrice(id,frame_id): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('id', id);
    httpParams = httpParams.append('frame_id', frame_id);
    return this.http.get<any>(this.siteApi + '/frames/featured-price', {
      params: httpParams
    })
        .pipe(
            map(res => res),
            catchError(this.handleError('find', null))
        );
  }

  getFeaturedFrameProductPrice(data): Observable<any> {
    let httpParams = new HttpParams();
    return this.http.get<any>(this.apiUrlUnAuth +'/getFeaturedFrameProductPrice?data='+data, {
      params: httpParams
    })
        .pipe(
            map(res => res),
            catchError(this.handleError('find', null))
        );
  }

  getFeaturedFrame(id): Observable<any> {
    return this.http.get<any>(this.siteApi + '/frames/featured/' + id)
        .pipe(
            map(res => res),
            catchError(this.handleError('find', null))
        );
  }

  
  add(element: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Accept: 'application/json, text/plain'
      })
    };
    
    return this.http.post<any>(this.apiUrlAuth +'/on_sale', element, httpOptions)
      .pipe(
        map(res => res),
        catchError(this.handleError('getOnSale', element))
      );
  }

  update(element: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Accept: 'application/json, text/plain'
      })
    };

    return this.http.put<any>(this.apiUrlAuth +'/on_sale', element, httpOptions)
      .pipe(
        map(res => res),
        catchError(this.handleError('getOnSale', element))
      );
  }

  updateStatus(id: number, status: number): Observable<any> {
    const element: any = {
      id: id,
      status: status,
      form: 'on_sale'
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Accept: 'application/json, text/plain'
      })
    };

    return this.http.put<any>(this.apiUrlAuth +'/status_change', element, httpOptions)
        .pipe(
            map(res => res),
            catchError(this.handleError('getBasicPaint', element))
        );
  }

  delete(ids = '[]'): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('ids', ids);
    return this.http.delete<any>(this.apiUrlAuth +'/on_sale', {
        params: httpParams
      })
      .pipe(
        map(res =>  res),
        catchError(this.handleError('deleteOnSale', null))
      );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
